import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import './font-awesome/css/font-awesome.css';
import { Router, Route, /*hashHistory, */ browserHistory } from 'react-router';
import TagManager from 'react-gtm-module';

TagManager.initialize({ gtmId: 'GTM-5RHDLW6' });

console.log("quickcalc build trigger"); // dummy log to retrigger pipeline

ReactDOM.render(
  <Router history={browserHistory}>
    <Route path="/" component={App} page="" />
    <Route path="newUser" component={App} page="newUser" />
    <Route path="forgot" component={App} page="forgot" />
    <Route path="project" component={App} page="project" />
    <Route path="rooms" component={App} page="rooms" />
    <Route path="room" component={App} page="room" />
    <Route path="room/:subPage" component={App} page="room" />
    <Route path="summary" component={App} page="summary" />
    <Route path="disclaimer" component={App} page="disclaimer" />
    <Route path="customer" component={App} page="customer" />
    <Route path="done" component={App} page="done" />
  </Router>,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/